export default __webpack_public_path__ + "static/media/USDT-AVAX.e66229af.png";